import { render, staticRenderFns } from "./VettingForm.vue?vue&type=template&id=104922bb&scoped=true"
import script from "./VettingForm.vue?vue&type=script&lang=js"
export * from "./VettingForm.vue?vue&type=script&lang=js"
import style0 from "./VettingForm.vue?vue&type=style&index=0&id=104922bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104922bb",
  null
  
)

export default component.exports